import React from 'react';
import {Route, Redirect} from 'react-router-dom';
// import {} from

const UserAdminRoute=({component: Component,...rest})=>{
    let authuser = sessionStorage.getItem('Key_Veriable')
    return(<Route
            {...rest}
                render ={(props)=>
                authuser==='ADMIN' || authuser==='USER'? (<Component {...props} />) :(<Redirect to ='/signin'/>)}/> )
};
export default UserAdminRoute